/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

const About = (props) => { 
    return (
        <div className="main">
            <MetaTags>       
                <title>About - LoudUp</title>     
                <meta id="description" name="description" content="The story behind LoudUp, why it was started, and what it aims to accomplish" />   
            </MetaTags>
            <div className="container">
                <div className="block-inner">
                    <div className="row">
                        <div className="col-sm-8 col-sm-push-2">
                            <article className="body-copy">
                                <header>
                                    <h1 className="section-alt">About Us</h1>
                                </header>
                                <div style={{lineHeight: "1.5em"}}>
                                    <p>LoudUp was born out of identifying a lack of opportunity for independent artists to showcase their music and increase their reach.</p>
                                    <p>While trying to promote gigs for independent artists, I realised that no matter how many flyers I give out, most people won't pay money to go and watch a band that they have never heard of. But then how can people hear your music easily?</p>
                                    <p>LoudUp aims to create a place where music fans can connect, discover new music, and find gigs in their area. A place where promoters can find local talent, and artists can showcase their material and connect with other artists, fans, musicians, producers, and songwriters.</p>
                                    <p>It is said that love is a universal language, understood by all. While this is true, I believe that music is also a universal language. I have experienced this 1st-hand, being in a foreign country surrounded by people I don't know, don't speak the same language with, and yet losing ourselves dancing together, all because of music! I love how powerful music can be. And music shared can bring about a connection that even words cannot compete with.</p>
                                    <p>That's what we aim to do. To create a forum for you to discover music that you love. Music that makes you feel something. And then enable you to share it with others.</p>
                                    <p style={{fontStyle: "italic"}}><br />Anne Adams<br />Founder</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;